import React from 'react';
import 'react-responsive-modal/styles.css';
import { Modal } from 'react-responsive-modal';
import '../../css/shared/RespModalAdmin.css';
function RespModalAdmin(props) {
  return (
    <Modal classNames="abc"  open={props.hasOpen} closeOnOverlayClick={false} closeIcon=' ' center>
      <div id="respmodeladmindiv" {...props}>
        {props.children}
      </div>
    </Modal>
  );
}
export default RespModalAdmin;
